import { Injectable } from "@angular/core";
import { SESSION_STORAGE_KEY } from "@core/configs";
import { BehaviorSubject } from "rxjs";
import { SessionStorageService } from "./session-storage.service";

@Injectable({ providedIn: 'root' })
export class AuthStateService {
  private accessToken$ = new BehaviorSubject<string | null>(null);
  private userId$ = new BehaviorSubject<string | null>(null);
  private roleId$ = new BehaviorSubject<string | null>(null);

    constructor(private sessionStorageService: SessionStorageService) { 

    }

  get accessToken(): string | null {
    return this.accessToken$.value;
  }

  get userId(): string | null {
    return this.userId$.value;
  }

  hydrateFromStorage(): void {
    this.accessToken$.next(this.sessionStorageService.getSessionData(SESSION_STORAGE_KEY.accessToken));
    this.userId$.next(this.sessionStorageService.getSessionData(SESSION_STORAGE_KEY.userId));
  }

  setAuthState(token: string, refreshToken: string, userId: string): void {
    this.accessToken$.next(token);
    this.userId$.next(userId);

    this.sessionStorageService.setSessionData(SESSION_STORAGE_KEY.accessToken, token);
    this.sessionStorageService.setSessionData(SESSION_STORAGE_KEY.refreshToken, refreshToken);
    this.sessionStorageService.setSessionData(SESSION_STORAGE_KEY.userId, userId);
  }

  updateAccessToken(token: string): void {
    this.accessToken$.next(token);

    this.sessionStorageService.setSessionData(SESSION_STORAGE_KEY.accessToken, token);
  }

  clear(): void {
    this.accessToken$.next(null);
    this.userId$.next(null);
    this.sessionStorageService.clearSessionStorage();
  }
}
